(function () {
  'use strict';

  var MOBILE_BREAKPOINT = 750;
  var DESKTOP_LIMIT = 6;

  function initCategoryCards(section) {
    if (section.dataset.categoryInitialized === 'true') return;
    section.dataset.categoryInitialized = 'true';

    var track = section.querySelector('[data-category-track]');
    var viewport = section.querySelector('[data-category-viewport]');
    var prevBtn = section.querySelector('[data-category-prev]');
    var nextBtn = section.querySelector('[data-category-next]');
    var items = Array.prototype.slice.call(section.querySelectorAll('[data-category-item]'));
    var desktopLimit = parseInt(section.dataset.desktopLimit, 10) || DESKTOP_LIMIT;
    var currentIndex = 0;

    if (!track || !items.length) return;

    function isMobile() {
      return window.innerWidth < MOBILE_BREAKPOINT;
    }

    function getVisibleCount() {
      if (isMobile()) return 1;
      return Math.min(items.length, desktopLimit);
    }

    function isCarouselMode() {
      return isMobile() || items.length > desktopLimit;
    }

    function getMaxIndex() {
      var visible = getVisibleCount();
      return Math.max(0, items.length - visible);
    }

    function clampIndex(index) {
      return Math.max(0, Math.min(index, getMaxIndex()));
    }

    function getGap() {
      return parseFloat(getComputedStyle(track).gap) || 0;
    }

    function getItemStep() {
      if (!items[0]) return 0;
      return items[0].offsetWidth + getGap();
    }

    function updateGridColumns() {
      if (isCarouselMode()) {
        section.classList.add('is-carousel');
        section.classList.remove('is-grid');
        track.style.transform = 'translateX(-' + currentIndex * getItemStep() + 'px)';
      } else {
        section.classList.remove('is-carousel');
        section.classList.add('is-grid');
        track.style.transform = '';
        section.style.setProperty('--cc-columns', String(items.length));
      }
    }

    function updateItemWidths() {
      var visible = getVisibleCount();
      var gap = getGap();
      var viewportWidth = viewport ? viewport.offsetWidth : section.offsetWidth;

      if (!isCarouselMode()) {
        section.style.removeProperty('--cc-item-width');
        return;
      }

      if (isMobile()) {
        var mobileWidth = (viewportWidth - gap * 0.15) / 1.15;
        section.style.setProperty('--cc-item-width', mobileWidth + 'px');
      } else {
        var totalGap = gap * (visible - 1);
        var itemWidth = (viewportWidth - totalGap) / visible;
        section.style.setProperty('--cc-item-width', itemWidth + 'px');
      }
    }

    function updateNav() {
      if (prevBtn) prevBtn.disabled = !isCarouselMode() || currentIndex <= 0;
      if (nextBtn) nextBtn.disabled = !isCarouselMode() || currentIndex >= getMaxIndex();
    }

    function goTo(index) {
      currentIndex = clampIndex(index);
      updateGridColumns();
      updateNav();
    }

    function refresh() {
      currentIndex = clampIndex(currentIndex);
      updateItemWidths();
      updateGridColumns();
      updateNav();
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        goTo(currentIndex - 1);
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        goTo(currentIndex + 1);
      });
    }

    var resizeTimer;
    window.addEventListener('resize', function () {
      window.clearTimeout(resizeTimer);
      resizeTimer = window.setTimeout(refresh, 150);
    });

    var touchStartX = 0;
    var touchDeltaX = 0;

    if (viewport) {
      viewport.addEventListener('touchstart', function (event) {
        if (!isCarouselMode()) return;
        touchStartX = event.touches[0].clientX;
        touchDeltaX = 0;
      }, { passive: true });

      viewport.addEventListener('touchmove', function (event) {
        if (!isCarouselMode()) return;
        touchDeltaX = event.touches[0].clientX - touchStartX;
      }, { passive: true });

      viewport.addEventListener('touchend', function () {
        if (!isCarouselMode() || Math.abs(touchDeltaX) < 40) return;
        if (touchDeltaX < 0) goTo(currentIndex + 1);
        else goTo(currentIndex - 1);
      });
    }

    refresh();
  }

  function initAll() {
    document.querySelectorAll('[data-category-cards]').forEach(initCategoryCards);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var section = event.target.querySelector('[data-category-cards]');
    if (section) initCategoryCards(section);
  });
})();
